// Dependencies
import axios from "axios";

const { REACT_APP_SERVER_URL, NODE_ENV } = process.env;
const dev = NODE_ENV === "development";

const baseURL = !dev ? REACT_APP_SERVER_URL : "http://localhost:8080";

const myFetch = (endpoint, config) => {
  const configFetch = {
    ...config,
  };
  return axios(baseURL.concat(endpoint), configFetch);
};

export const login = (username, password) => {
  return myFetch("/login", {
    method: "POST",
    data: { username, password },
  });
};

export const logout = () => {
  return myFetch("/logout", {
    method: "GET",
  });
};
